import { Box, fade, withStyles } from '@material-ui/core';
import { ToggleButton } from '@material-ui/lab';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsSubtitle from 'ui-elements/typography/FsSubtitle';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodyExtraSmall from 'ui-elements/typography/FsBodyExtraSmall';

const tempLg = 1400;

export const ButtonTab = withStyles(({ palette, spacing, breakpoints }) => ({
  root: {
    width: '100%',
    display: 'block',
    textAlign: 'left',
    backgroundColor: 'transparent',
    padding: spacing(2),
    border: 0,
    textTransform: 'none',
    position: 'relative',
    transition: 'background-color .2s linear',
    '& p, & span, & h4, & strong': {
      transition: 'color .2s linear',
    },
    '& svg path': {
      transition: 'stroke .2s linear',
    },
    '& .MuiTouchRipple-root': {
      // class responsible for light effect modification
      bottom: -11,
      color: fade(palette.common.white, 0.5),
    },
    '& i.arrow': {
      content: '""',
      position: 'absolute',
      top: '100%',
      left: '50%',
      transform: 'translate(-50%, -50%) rotate(45deg)',
      width: spacing(2),
      height: spacing(2),
      background: palette.grey[100],
      transition: 'background .2s linear',
    },
    '&:hover': {
      background: palette.grey[200],
      '& i.arrow': {
        background: palette.grey[200],
      },
    },
    [breakpoints.up('md')]: {
      padding: spacing(4),
    },
    [breakpoints.up(tempLg)]: {
      '& i.arrow': {
        top: '50%',
        left: 'auto',
        right: '100%',
        transform: 'translate(50%, 0) rotate(45deg)',
      },
      '& .MuiTouchRipple-root': {
        bottom: 0,
        left: -11,
      },
    },
  },
  selected: {
    transition: 'background-color .3s linear',
    background: `${palette.primary.main}!important`,
    '& p, & span, & h4, & strong': {
      transition: 'color .3s linear',
      color: `${palette.common.white}!important`,
    },
    '& svg path': {
      transition: 'stroke .3s linear',
      stroke: `${palette.common.white}!important`,
    },
    '& i.arrow': {
      transition: 'background .3s linear',
      background: `${palette.primary.main} !important`,
    },
    // [breakpoints.up('lg')]: {
    //   '&:after': {
    //     borderTopColor: `transparent`, // reset mobile border styles
    //     // borderTop: `none`, // reset mobile border styles
    //     borderRightColor: palette.primary.main-elements,
    //   },
    // },
  },
}))(ToggleButton);

export const Percentage = withStyles(({ palette }) => ({
  root: {
    fontSize: 44,
    lineHeight: 1.2,
    color: palette.grey[400],
    '& > span': {
      fontWeight: 400,
    },
  },
}))(FsBodyBold);

export const PercentageLabel = withStyles(({ spacing }) => ({
  root: {
    marginLeft: spacing(1),
  },
}))(FsBodySmall);

export const Name = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[400],
  },
}))(FsSubtitle);

export const ItemsWrapperBox = withStyles(({ palette, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: spacing(2),
    borderRight: `1px solid ${palette.grey[100]}`,
  },
}))(Box);

export const ItemLabel = withStyles(() => ({
  root: {},
}))(FsBodySmall);

export const ItemValue = withStyles(({ palette }) => ({
  root: {
    fontWeight: 500,
    color: palette.grey[400],
  },
}))(FsBodySmall);

export const ResultWrapperBox = withStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: spacing(2),
  },
}))(Box);

export const ResultValue = withStyles(({ palette }) => ({
  root: {
    fontWeight: 500,
    color: palette.grey[400],
  },
}))(FsBody);

export const ResultLabel = withStyles(() => ({
  root: {},
}))(FsBodyExtraSmall);
